<template>
  <div class="copyright-section">
    <p data-testid="copyright-statement" class="copyright-statement elr-text-center">&copy;{{currentYear}} All Rights Reserved MyLittlePonyCollection -
    <router-link to="/privacy">Privacy Policy</router-link> -
    <router-link to="/disclaimer">Disclaimer</router-link></p>
  </div>
</template>

<script>
export default {
  name: 'CopyrightSection',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.copyright-section {
  background-color: $black;
  padding: 20px 0;
}

.copyright-statement {
  font-size: 12px;
  text-align: center;
  color: #fff;
  padding: 0;
  margin: 0;

  a {
    color: $accent-color;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: lighten($accent-color, 20%);
      text-decoration: none;
    }
  }
}
</style>
